export default "__VITE_ASSET__C71uF6Yn__"